import styled from '@emotion/styled/macro';

export const Flex = styled.div`
    display: flex;
    flex-direction: column;
`;
